<template>
    <div id="Clinician__Alerts" class="dashboard-card d-flex">
        <CardTemplate borderClass="task-alerts-section task-alert-padding">
            <!-- HEADER -->
            <template v-slot:header>
                <section class="card-title">
                    <span> Alerts</span>
                    <span class="ms-1" v-if="tasksList.length"> ({{ tasksList.length }}) </span>
                    <a
                        tabindex="0"
                        href="javascript:void(0);"
                        role="button"
                        v-custom-popover="{ content: tooltip, className: 'font-size-sm info-popup' }"
                    >
                        <i class="fas fa-info-circle text-primary ms-2"></i>
                    </a>
                </section>
                <section class="ms-auto d-flex align-items-center cursor-pointer">
                    <div
                        v-show="tasksList.length"
                        v-tooltip="{ title: `Click to sort visits by schedule date.` }"
                        @click="sortByScheduleDate()"
                        class="d-flex flex-column align-items-center"
                    >
                        <span class="icon small">
                            <i :class="isAscending ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'"></i>
                            <i class="fas fa-calendar-alt"></i>
                        </span>
                        <span class="text font-size-sm fw-bold me-2 blue-text">Sort</span>
                    </div>
                </section>
            </template>

            <!-- CONTENT -->
            <!-- LOADING -->
            <template v-slot:content>
                <div class="mt-3 text-center" v-if="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading your Alerts</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-if="hasError && !isLoading">
                    <p>
                        There was a problem while fetching your alerts.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getReturnedByQATasks()">Try Again</button>
                </div>
                <!-- NO DATA -->
                <section v-if="tasksList.length === 0 && !isLoading && !hasError" class="no-data">
                    <i class="mb-3"> Good Job! There were no issues identified with your visits. </i>
                </section>
                <!-- DATA -->
                <div
                    v-if="tasksList.length > 0 && !isLoading && !hasError"
                    class="d-flex flex-column h-100 overflow-auto"
                    :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                >
                    <div class="alerts" v-for="task in tasksList" :key="task.Id">
                        <section class="task-info">
                            <div class="d-flex justify-content-between">
                                <span class="font-size-xs grey-secondary-text">
                                    Schedule Date {{ formatDate(task.Date) }}
                                </span>
                                <button @click="startTask(task)" class="fw-bold btn btn-primary">Review Visit</button>
                            </div>
                            <span class="grey-secondary-text"> {{ task.VisitName }} - {{ task.StatusName }} </span>
                            <a href="javascript:void(0);" @click="viewPatient(task)" class="fw-bold font-size-base">
                                {{ task.patientFullName }}
                            </a>

                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center">
                                    <ProductPill
                                        class="application-name"
                                        :product-id="getApplicationId(task.Application)"
                                    />
                                    <div
                                        class="text-default ms-2 font-size-2xs"
                                        v-tooltip="{ title: task.agencyTooltip, placement: 'top' }"
                                    >
                                        {{ task.BranchName }}
                                    </div>
                                </div>
                                <div v-if="isHomeCare(task.Application)">
                                    <i
                                        v-if="task.ReturnComments"
                                        v-tooltip="{
                                            title: getReturnComments(task.ReturnComments),
                                            placement: 'top',
                                            className: 'orange-note'
                                        }"
                                        class="fas fa-sticky-note orange-note mx-2"
                                    ></i>
                                </div>
                                <div v-else>
                                    <i
                                        v-if="task.ReturnComments"
                                        v-tooltip="{
                                            title: getReturnComments(task.ReturnComments),
                                            placement: 'top',
                                            className: 'red-note'
                                        }"
                                        class="fas fa-sticky-note red-note mx-2"
                                    ></i>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./TaskAlerts.ts"></script>
<style src="./TaskAlerts.scss"></style>
